import { readLedgerList } from '@/api/balancer/read';
import { statusFilter } from '@/lib/filter/status';
import { SUCCESS } from '@/lib/name-space';
import useUserStore from '@/store/user';
import type { ResReadPointLedgerListType } from '@/types';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PointsEarned() {
  const [list, setList] = useState<ResReadPointLedgerListType[] | []>([]);

  const { ids } = useUserStore();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!ids.pointId) {
        navigate('/');
        return;
      }
      const re = await readLedgerList(ids);
      if (re.status !== SUCCESS) {
        console.log('error');
        // modal
        return;
      }
      const data = re.data;
      setList(data);
    })();
    return () => {};
  }, []);

  return (
    <>
      <div className="border-b-3 flex h-[53px] items-center gap-[6px] border-[#B2B2B2] bg-[#FF6535] px-[16px] py-[20px]">
        <div className="mb-[3px] h-[8px] w-[8px] rounded-full bg-white" />
        <h1 className="text-[15px] font-[800] text-white">POINTS EARNED</h1>
      </div>

      <div className="h-[calc(100dvh-117px)] bg-white px-[10px] py-[17px]">
        <div className="brown-scrollbar flex max-h-[calc(100dvh-151px)] flex-col gap-[10px] overflow-y-auto pl-[6px] pr-[9px]">
          {list.map((item: ResReadPointLedgerListType, index: number) => (
            <div
              key={`item.title${index}`}
              className={`flex items-center gap-[9px] rounded-2xl border-2 border-[#FF6839] px-[17px] py-[15px] text-[11px] text-[#4F4F4F]`}
            >
              <span>{item.regDt}</span>
              <div className="h-[14px] w-[1px] bg-[#B2B2B2]"></div>
              <span>{statusFilter(item.status)}</span>
              <span className="ml-auto text-[13px] font-[800] text-[#FF6535]">{item.amount}P</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
